import playerTemplate from './player';
import templateTrainingGroup from './training-group';
import templateTrainingGroupSlider from './training-group-slider';
import templateTrainingOptions from './training-options';
import templateAutoTrainingOptions from './auto-training-options';

export {
  playerTemplate,
  templateTrainingGroup,
  templateTrainingOptions,
  templateAutoTrainingOptions,
  templateTrainingGroupSlider,
};
